import { CometThemeStyles } from '../data-types/styles/CometThemeStyles';
import { ICometThemePalette } from '../data-types/styles/ICometThemePalette';
import { useCorptaxTheme } from './useCorptaxTheme';

export function useCometStyles(palette: ICometThemePalette) {
    const theme = useCorptaxTheme();
    const cscStyles = new CometThemeStyles(theme, palette);
    return cscStyles;
}
